export enum SupportLanguageEnum {
  en = 'en',
  pl = 'pl',
  de = 'de',
  fr = 'fr',
  es = 'es',
  pt = 'pt',
  ja = 'ja',
  sv = 'sv',
}

export const UI_LANGUAGES: { code: SupportLanguageEnum; label: string }[] = [
  { code: SupportLanguageEnum.en, label: 'English' },
  { code: SupportLanguageEnum.de, label: 'Deutsch' },
  { code: SupportLanguageEnum.es, label: 'Español' },
  { code: SupportLanguageEnum.fr, label: 'Français' },
  { code: SupportLanguageEnum.ja, label: '日本語' },
  { code: SupportLanguageEnum.pl, label: 'Polski' },
  { code: SupportLanguageEnum.pt, label: 'Português' },
  { code: SupportLanguageEnum.sv, label: 'Svenska' },
];
